import Api from './../../services/Api.js';

const state = {
	emailsPerMinute: [],
	overallSubscribers: [],
	openClickBouncePieChartData: [],
	openClickBounceOverview: [],
	openClickBounceDetails: [],
	subscribeUnsubscribeOverview: [],
	subscribeUnsubscribeDetails: [],
	subscribeUnsubscribePieChartData: [],
	users: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	freeSite: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	proSite: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	completedCampaign: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	conversionRate: {
		count: 0,
	},
};

const getters = {
	getEmailsPerMinute(state) {
		if (state.emailsPerMinute.length === 0) return { labels: [], values: [] };
		const labels = [];
		const values = [];
		state.emailsPerMinute.forEach((item) => {
			labels.push(item.minute);
			values.push(item.count);
		});
		return { labels: labels, values: values };
	},
	getOverallSubscribers(state) {
		if (state.overallSubscribers.length === 0) return { labels: [], values: [] };
		const labels = [];
		const values = [];
		state.overallSubscribers.forEach((item) => {
			labels.push(item.Day);
			values.push(item.count);
		});
		return { labels: labels, values: values };
	},
	getOpenClickBouncePieChartData(state) {
		return state.openClickBouncePieChartData;
	},
	openClickBounceOverview(state) {
		return state.openClickBounceOverview;
	},
	openClickBounceDetails(state) {
		return state.openClickBounceDetails;
	},
	subscribeUnsubscribeOverview(state) {
		return state.subscribeUnsubscribeOverview;
	},
	subscribeUnsubscribeDetails(state) {
		return state.subscribeUnsubscribeDetails;
	},
	getSubscribeUnsubscribePieChartData(state) {
		return state.subscribeUnsubscribePieChartData;
	},
};

const actions = {
	async OPEN_CLICK_BOUNCE_PIE_CHART_DATA({commit}, params) {
		await Api.get("stats/open-click-bounce", {params})
			.then(res => {
				commit('COMMIT_OPEN_CLICK_BOUNCE_PIE_CHART_DATA', res.data)
			});
	},
	async SUBSCRIBE_UNSUBSCRIBE_PIE_CHART_DATA({commit}, params) {
		await Api.get("stats/subscribe-unsubscribe", {params})
			.then(res => {
				commit('COMMIT_SUBSCRIBE_UNSUBSCRIBE_PIE_CHART_DATA', res.data)
			});
	},
	async GET_EMAILS_PER_MINUTE_FroM_API({commit}, params) {
		await Api.get("reports/emails-sent", {params})
			.then(res => {
				commit('SET_EMAILS_PER_MINUTE_INTO_STATE', res.data.data)
			});
	},
	async GET_OVERALL_SUBSCRIBERS_FroM_API({commit}, params) {
		await Api.get("stats/overall-subscriber", {params})
			.then(res => {
				commit('SET_OVERALL_SUBSCRIBERS_INTO_STATE', res.data)
			});
	},
	async GET_OPEN_CLICK_BOUNCE_OVERVIEW({commit}, params) {
		await Api.get('stats/open-click-bounce/overview', { params })
			.then(res => commit('COMMIT_OPEN_CLICK_BOUNCE_OVERVIEW', res.data));
	},
	async GET_OPEN_CLICK_BOUNCE_DETAIL({commit}, params) {
		await Api.get('stats/open-click-bounce/details', { params })
			.then(res => commit('COMMIT_OPEN_CLICK_BOUNCE_DETAILS', res.data));
	},
	async SUBSCRIBE_UNSUBSCRIBE_OVERVIEW({commit}, params) {
		await Api.get('stats/subscribe-unsubscribe/overview', { params })
			.then(res => commit('COMMIT_SUBSCRIBE_UNSUBSCRIBE_OVERVIEW', res.data));
	},
	async SUBSCRIBE_UNSUBSCRIBE_DETAIL({commit}, params) {
		await Api.get('stats/subscribe-unsubscribe/details', { params })
			.then(res => commit('COMMIT_SUBSCRIBE_UNSUBSCRIBE_DETAILS', res.data));
	},
	GET_USERS({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let url = handleQueryFilter(payload, 'reports/users/total');

			Api.get(url)
				.then(res => {
					commit('getUsers', res.data);
					resolve({ users: state.users });
				})
				.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
	GET_FREE_SITE({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let url = handleQueryFilter(payload, 'stats/free-site');

			Api.get(url)
				.then(res => {
					commit('getFreeSite', res.data);
				})
				.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},

	GET_PRO_SITE({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let url = handleQueryFilter(payload, 'stats/pro-site');

			Api.get(url)
				.then(res => {

					commit('getProSite', res.data);
				})
				.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},

	GET_COMPLETED_CAMPAIGN({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let url = handleQueryFilter(payload, 'stats/completed-campaign');

			Api.get(url)
				.then(res => {

					commit('getCompletedCampaign', res.data);
				})
				.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},

	GET_CONVERSION_RATE_SITE({ commit }, payload) {
		return new Promise((reject) => {
			let url = `stats/conversion-rate`;
			if (payload.refresh) {
				url += `?refresh=${payload.refresh}`
			}
			Api.get(url)
				.then(res => {
					commit('getConversionRate', res.data);
				})
				.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
};

function handleQueryFilter (payload, subUrl) {
	let query = payload.query;
	if (!query) {
		query = '30-days';
	}
	let url = `${subUrl}?q=${query}`;
	if (payload.refresh) {
		url += `&refresh=${payload.refresh}`
	}
	return url;
}

const mutations = {
	COMMIT_OPEN_CLICK_BOUNCE_PIE_CHART_DATA(state, data) {
		state.openClickBouncePieChartData = data;
	},
	COMMIT_SUBSCRIBE_UNSUBSCRIBE_PIE_CHART_DATA(state, data) {
		state.subscribeUnsubscribePieChartData = data;
	},
	SET_EMAILS_PER_MINUTE_INTO_STATE(state, data) {
		state.emailsPerMinute = data;
	},
	SET_OVERALL_SUBSCRIBERS_INTO_STATE(state, data) {
		state.overallSubscribers = data;
	},
	COMMIT_OPEN_CLICK_BOUNCE_OVERVIEW(state, data) {
		state.openClickBounceOverview = data;
	},
	COMMIT_OPEN_CLICK_BOUNCE_DETAILS(state, data) {
		state.openClickBounceDetails = data;
	},
	COMMIT_SUBSCRIBE_UNSUBSCRIBE_OVERVIEW(state, data) {
		state.subscribeUnsubscribeOverview = data;
	},
	COMMIT_SUBSCRIBE_UNSUBSCRIBE_DETAILS(state, data) {
		state.subscribeUnsubscribeDetails = data;
	},
	getUsers(state, data) {
		state.users = data;
	},
	getFreeSite(state, data) {
		state.freeSite = data;
	},
	getProSite(state, data) {
		state.proSite = data;
	},
	getConversionRate(state, data) {
		state.conversionRate = data;
	},
	getCompletedCampaign(state, data) {
		state.completedCampaign = data;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};